import {
  HeyLightCheckoutForm,
  HeyLightCheckoutFormData,
} from "./HeyLightCheckoutForm.tsx";
import { Layout } from "../UI/Layout/Layout.tsx";
import { NavBar } from "../UI/Layout/NavBar.tsx";
import { useProductIdFormQueryString } from "./useProductIdFormQueryString.ts";
import { useHeyLightProductById } from "./useHeyLightProductById.ts";
import { FullPageLoading } from "../UI/FullPageLoading.tsx";
import { MainContainer } from "../UI/Layout/MainContainer.tsx";
import { Footer } from "../UI/Layout/Footer.tsx";
import { useCreateHeyLightOrder } from "./useCreateHeyLightOrder.ts";
import { useState } from "react";
import { ErrorPopup } from "../UI/Error/ErrorPopup.tsx";
import { usePopupController } from "./usePopupController.ts";
import { useAnalyticsParams } from "../MoneyTransfer/useAnalyticsParams.ts";
export const HeyLightCheckoutScreenPath = "/heylight/checkout";

function HeyLightCheckoutScreenInner({ productId }: { productId: string }) {
  const { product, isLoading } = useHeyLightProductById(productId);

  const [creatingOrder, setCreatingOrder] = useState(false);
  const { createHeyLightOrder } = useCreateHeyLightOrder();
  const { openPopup, closePopup, open, title, description } =
    usePopupController();
  const { analyticsParams } = useAnalyticsParams();

  const createOrder = async (data: HeyLightCheckoutFormData) => {
    try {
      setCreatingOrder(true);
      const { order } = await createHeyLightOrder(
        data,
        productId,
        analyticsParams,
      );
      window.location.href = order.heyLightInformation.heyLightRedirectUrl;
    } catch {
      openPopup({
        title: "Errore",
        description:
          "Si è verificato un errore durante la creazione dell'ordine. Riprova più tardi.",
        timeoutMs: 5000,
      });
      setCreatingOrder(false);
    }
  };

  if (isLoading) return <FullPageLoading />;
  if (!product) return <p>Product not found</p>; //TODO: handle this better
  return (
    <Layout>
      <NavBar />
      <MainContainer>
        <ErrorPopup
          open={open}
          onClose={closePopup}
          title={title}
          description={description}
        />
        <HeyLightCheckoutForm
          submitting={creatingOrder}
          onFormSubmit={createOrder}
          product={product}
        />
      </MainContainer>
      <Footer />
    </Layout>
  );
}
export function HeyLightCheckoutScreen() {
  const { productId } = useProductIdFormQueryString();
  if (!productId) return <p>Product not found</p>; //TODO: handle this better
  return <HeyLightCheckoutScreenInner productId={productId} />;
}
